export function getLocalDateTime(dateObj) {
  return dateObj.toLocaleString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  })
}

export function getAge(birthYear) {
  return String(new Date().getFullYear() - Number(birthYear))
}

// Returns length of LCS for X[0..m-1], Y[0..n-1]
function lcs(X, Y) {
  var m = X.length
  var n = Y.length
  var L = new Array(m + 1);
  for (let i = 0; i < L.length; i++) {
    L[i] = new Array(n + 1);
  }

  var i, j;

  /* Following steps build L[m+1][n+1] in
  bottom up fashion. Note that L[i][j]
  contains length of LCS of X[0..i-1]
  and Y[0..j-1] */
  for (i = 0; i <= m; i++) {
    for (j = 0; j <= n; j++) {
      if (i === 0 || j === 0)
        L[i][j] = 0;
      else if (X[i - 1] === Y[j - 1])
        L[i][j] = L[i - 1][j - 1] + 1;
      else
        L[i][j] = Math.max(L[i - 1][j], L[i][j - 1]);
    }
  }

  /* L[m][n] contains length of LCS
  for X[0..n-1] and Y[0..m-1] */
  return L[m][n];
}

export function match(someList, friendsList) {
  var lowerA = someList.map(x => x.name.toLowerCase())
  var lowerB = friendsList.map(y => y.toLowerCase())

  // var result = []

  for (let i = 0; i < lowerA.length; i++) {
    for (let j = 0; j < lowerB.length; j++) {
      let x = lowerA[i]
      let y = lowerB[j]
      if (lcs(x, y) >= 0.9 * Math.min(x.length, y.length)) {
        // As soon as one name matches, return it
        return someList[i]

        // result.push(someList[i])
        // return result
      }
    }
  }

  // return result
  return null
}

export function decideName(options, myList) {
  let options_fNames = options.map(name => name.toLowerCase().split(' ')[0])
  let myList_fNames = myList.map(name => name.toLowerCase().split(' ')[0])

  let length = options.length

  for (let i = 0; i < length; i++) {
    let name = options_fNames[i]
    if (!myList_fNames.includes(name)) {
      return options[i]
    }
  }

  return options[0]
}

const fakeNames = [
  'Thomas', 'Harry', 'Herbert', 'Shane', 'Allan', 'Christopher',	'Fred',	'Frederick', 'Ricardo',	'Nelson', 'Daniel', 'Wayne', 'Ray', 'Sam',
  'James', 'Willie', 'Chad', 'Zachary', 'Mathew', 'John', 'Ralph', 'Jacob', 'Corey', 'Tyrone', 'Robert', 'Lawrence', 'Lee', 'Herman', 'Darren',
  'Michael', 'Nicholas', 'Melvin', 'Maurice', 'Lonnie', 'William', 'Roy', 'Alfred', 'Vernon', 'Lance', 'David', 'Benjamin', 'Kyle', 'Roberto', 'Cody',
  'Richard', 'Bruce', 'Francis', 'Clyde', 'Julio', 'Charles', 'Brandon', 'Bradley', 'Glen', 'Kelly', 'Joseph', 'Adam', 'Jesus', 'Hector', 'Kurt',

  'Dorothy', 'Christina', 'Charlotte', 'Yolanda', 'Lisa', 'Kathy', 'Monica', 'Jeanette', 'Vickie', 'Nancy', 'Theresa', 'Esther', 'Laurie', 'Mattie',
  'Mary', 'Katherine', 'Josephine', 'Ana', 'Heidi', 'Patricia', 'Joan', 'Thelma', 'Renee', 'Glenda', 'Linda', 'Ashley', 'Shannon', 'Ida', 'Lydia',
  'Barbara', 'Judith', 'Sheila', 'Vivian', 'Viola', 'Elizabeth', 'Rose', 'Ethel', 'Roberta', 'Courtney', 'Jennifer', 'Janice', 'Ellen', 'Holly', 'Marian',
  'Maria', 'Kelly', 'Elaine', 'Brittany', 'Stella', 'Susan', 'Nicole', 'Marjorie', 'Melanie', 'Caroline', 'Margaret', 'Judy', 'Carrie', 'Loretta', 'Dora',
]

const fakeSurnames = [
  'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller', 'Davis', 'Rodriguez', 'Martinez', 'Hernandez', 'Lopez', 'Gonzalez', 'Wilson', 'Anderson', 'Thomas',
  'Taylor', 'Moore', 'Jackson', 'Martin', 'Lee', 'Perez', 'Thompson', 'White', 'Harris', 'Sanchez', 'Clark', 'Ramirez', 'Lewis', 'Robinson', 'Walker', 'Young',
  'Allen', 'King', 'Wright', 'Scott', 'Torres', 'Nguyen', 'Hill', 'Flores', 'Green', 'Adams', 'Nelson', 'Baker', 'Hall', 'Rivera', 'Campbell', 'Mitchell', 'Carter', 'Roberts'
]

// Function to get random high / low counts
export function getCounts(indication) {
  let lowMin = 3, lowMax = 5, highMin = 1800, highMax = 2000
  let flaggersCount = indication[0] === 'L' ?
    lowMin + Math.floor(Math.random() * (lowMax - lowMin + 1)) :
    highMin + Math.floor(Math.random() * (highMax - highMin + 1))
  let sharersCount = indication[1] === 'L' ?
    lowMin + Math.floor(Math.random() * (lowMax - lowMin + 1)) :
    highMin + Math.floor(Math.random() * (highMax - highMin + 1))
  return { flaggersCount, sharersCount }
}


// Function to get random high / low counts
export function getAdCounts(indication) {
  let lowMin = 3, lowMax = 5, highMin = 1800, highMax = 2000
  let likersCount = indication[0] === 'L' ?
    lowMin + Math.floor(Math.random() * (lowMax - lowMin + 1)) :
    highMin + Math.floor(Math.random() * (highMax - highMin + 1))
  let sharersCount = indication[1] === 'L' ?
    lowMin + Math.floor(Math.random() * (lowMax - lowMin + 1)) :
    highMin + Math.floor(Math.random() * (highMax - highMin + 1))
  return { likersCount, sharersCount }
}


// Function to get random high / low counts for likes
export function getLikeCounts(indication) {
  let lowMin = 3, lowMax = 5, highMin = 1800, highMax = 2000
  let likersCount = 0 // this corresponds to indication === 'N' (No likes)
  
  if (indication === 'L') {
    likersCount = lowMin + Math.floor(Math.random() * (lowMax - lowMin + 1))
  } else if (indication === 'H'){
    likersCount = highMin + Math.floor(Math.random() * (highMax - highMin + 1))
  }
  return { likersCount }
}




export function getFakeList(n) {
  let output = []
  for (let i = 0; i < n; i++) {
    output.push(fakeNames[Math.floor(Math.random()*fakeNames.length)] + ' ' + fakeSurnames[Math.floor(Math.random()*fakeSurnames.length)])
  }
  return output
}

export function getLists(indication) {
  let lowMin = 3, lowMax = 5, highMin = 1800, highMax = 2000
  let flaggersCount = indication[0] === 'L' ?
    lowMin + Math.floor(Math.random() * (lowMax - lowMin + 1)) :
    highMin + Math.floor(Math.random() * (highMax - highMin + 1))
  let sharersCount = indication[1] === 'L' ?
    lowMin + Math.floor(Math.random() * (lowMax - lowMin + 1)) :
    highMin + Math.floor(Math.random() * (highMax - highMin + 1))

  let i, flaggersList = [], sharersList = []
  for (i = 0; i < flaggersCount; i++) {
    flaggersList.push(fakeNames[Math.floor(Math.random()*fakeNames.length)] + ' ' + fakeSurnames[Math.floor(Math.random()*fakeSurnames.length)])
  }
  for (i = 0; i < sharersCount; i++) {
    sharersList.push(fakeNames[Math.floor(Math.random()*fakeNames.length)] + ' ' + fakeSurnames[Math.floor(Math.random()*fakeSurnames.length)])
  }
  return { flaggersList, sharersList }
}


export function getAdLists(indication) {
  let lowMin = 3, lowMax = 5, highMin = 1800, highMax = 2000
  let likersCount = indication[0] === 'L' ?
    lowMin + Math.floor(Math.random() * (lowMax - lowMin + 1)) :
    highMin + Math.floor(Math.random() * (highMax - highMin + 1))
  let sharersCount = indication[1] === 'L' ?
    lowMin + Math.floor(Math.random() * (lowMax - lowMin + 1)) :
    highMin + Math.floor(Math.random() * (highMax - highMin + 1))

  let i, likersList = [], sharersList = []
  for (i = 0; i < likersCount; i++) {
    likersList.push(fakeNames[Math.floor(Math.random()*fakeNames.length)] + ' ' + fakeSurnames[Math.floor(Math.random()*fakeSurnames.length)])
  }
  for (i = 0; i < sharersCount; i++) {
    sharersList.push(fakeNames[Math.floor(Math.random()*fakeNames.length)] + ' ' + fakeSurnames[Math.floor(Math.random()*fakeSurnames.length)])
  }
  return { likersList, sharersList }
}




// Function to jumble an array in-place
export function jumble(arr) {
  let n = arr.length, i, j, temp
  for (i = n - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i+1))
    temp = arr[i]
    arr[i] = arr[j]
    arr[j] = temp
  }
  return arr
}


// Function to generate random number:
// if max = 1: always generates 0
//    max = 2: randomly pick from {0, 1}

export function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}



// Function to extend an array (in-place) to a given length by picking random elements
export function extend(arr, l) {
  let n = arr.length
  if (n >= l) {
    return arr
  }
  let i, j
  for (i = 1; i <= l - n; i++) {
    j = Math.floor(Math.random() * n)
    arr.push(arr[j])
  }
  return arr
}

